import React from 'react';
import Lottie from 'react-lottie';
import animationData from "./playerLoader.json"

const Loader = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className="loader" style={{ width: "29.33px", height: "33px" }}>
            <Lottie
                options={defaultOptions}

            />
        </div>
    );
};

export default Loader;
